export const ConvertMegaBytesToBytes = (megaBytes) => +(megaBytes * 1024 * 1024).toFixed(9);
export const ConvertBytesToMegaBytes = (bytes) => +(bytes / (1024 * 1024)).toFixed(2);
//# sourceMappingURL=ConvertToByteUtils.js.map